import React from 'react'
import ReactDOM from 'react-dom'
import App from './app.js'
import './index/normalize.css'
import './index/skeleton.css'
import './index.css'

ReactDOM.render(
  <App />,
  document.getElementById('root')
)



// WEBPACK FOOTER //
// ./src/index.js